import { ControlValueAccessor } from '@angular/forms';

export class ControlValueAccessorBase<T> implements ControlValueAccessor {
  value: T;
  disabled = false;
  onChange = (value: T) => {};
  onTouched = () => {};

  writeValue(value: T): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
